function isActiveColour(button, colour) {
    const selectedIndex = button.getAttribute('data-model-colour-index');

    return colour.getAttribute('data-for-model-colour-index') == selectedIndex;
}

function selectColour(button) {
    const colours = [...document.querySelectorAll('.js_oraColourPicker__item')];

    colours.find(colour => isActiveColour(button, colour)).classList.add('oraColourPicker__item--active');
    colours.filter(colour => !isActiveColour(button, colour))
           .forEach(colour => colour.classList.remove('oraColourPicker__item--active'));
}

function init() {
    const buttons = document.querySelectorAll('.js_oraColourPicker__swatchButton');
    
    buttons.forEach(button => button.addEventListener('click', e => selectColour(button)));
}

$(document).ready(init);
